import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectOrganizer } from '@deltager/organizers/admin/redux/root.state';
import { first } from 'rxjs/operators';
import { OrganizerSettings } from '@deltager/organizers/admin/shared/models/OrganizerSettings';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrganizerSettingsResolver implements Resolve<OrganizerSettings> {
  private _store = inject(Store);

  public resolve(_: ActivatedRouteSnapshot): Observable<OrganizerSettings> {
    return this._store.select(selectOrganizer).pipe(
      first(x => !!x)
    );
  }
}
